import { useState } from 'react';
import type { VideoItem } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';

interface LatestVideosProps {
  videos: VideoItem[];
}

const PAGE_SIZE = 8;

export default function LatestVideos({ videos }: LatestVideosProps) {
  const [visible, setVisible] = useState(PAGE_SIZE);
  const shown = videos.slice(0, visible);
  const hasMore = visible < videos.length;

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="mb-6">
        <h2 className="font-display text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-3">
          <span className="w-1.5 h-6 rounded-full bg-primary-500"></span>
          最新上线
        </h2>
        <p className="mt-2 text-xs md:text-sm text-foreground-500 pl-4">
          按更新时间排序，第一时间发现新上架的视频内容
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
        {shown.map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>

      {hasMore && (
        <div className="mt-8 flex justify-center">
          <button
            type="button"
            onClick={() => setVisible((v) => v + PAGE_SIZE)}
            className="inline-flex items-center gap-2 px-8 py-3 rounded-md border border-background-300 bg-background-100 hover:bg-background-200 hover:border-primary-300 text-sm font-medium text-foreground-800 whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-refresh-line text-lg"></i>
            加载更多
          </button>
        </div>
      )}
    </section>
  );
}